import { render, staticRenderFns } from "./PushNotificationsCheckbox.vue?vue&type=template&id=7d30e624"
import script from "./PushNotificationsCheckbox.vue?vue&type=script&lang=js"
export * from "./PushNotificationsCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports